var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-preloader-overlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_vm.isEmpty ? _c('subscription-empty-list') : _c('div', {
    staticClass: "capusta-container"
  }, [_c('div', {
    staticClass: "header-container"
  }, [_c('subscriptions-header'), _vm.periodicRecurrentPaymentPermission ? _c('div', {
    staticClass: "bill-created"
  }, [_c('a', {
    staticClass: "button thin action",
    on: {
      "click": _vm.onRouteSubscription
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('organize.subscription')))])])]) : _vm._e()], 1), _c('subscription-filter', {
    ref: "SubscriptionFilters"
  }), _c('subscriptions-groups', {
    attrs: {
      "subscriptions-groups": _vm.preparedByGroupSubscriptions
    },
    on: {
      "unfollow": _vm.onShownUnfollowDialog
    }
  }), _c('cs-dialog', {
    model: {
      value: _vm.isShownConfirmationUnfollowing,
      callback: function callback($$v) {
        _vm.isShownConfirmationUnfollowing = $$v;
      },
      expression: "isShownConfirmationUnfollowing"
    }
  }, [_c('dialog-default-layout', [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('you.want.unsubscribe.for.this.user')))]), _c('div', {
    staticClass: "confirmation-unfollowing-controls",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('cs-button', {
    on: {
      "click": _vm.onUnfollow
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _c('cs-button', {
    attrs: {
      "type": "transparent"
    },
    on: {
      "click": _vm.onCloseDialogUnfollow
    }
  }, [_vm._v(_vm._s(_vm.$t('common.cancel')))])], 1)])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }